import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { useModal } from '../../hooks/use-modal';
import { MapRequestedServiceModal } from '../../components/modals/map-requested-service-modal';
import { SaveRequestedService } from '../../components/modals/map-requested-service-modal/save-requested-service';
import { ModalPortal } from '../../components/modal-portal';

import { FulfillmentPlannerProperties } from '../../store/csw/fulfillment-planner-properties';
import { messages } from '../messages';
import { useFulfillmentPlannerContext } from '../context';

import style from './style.module.css';

const localizedUnmappedServiceDisplayText = <FormattedMessage {...messages.unmappedServiceDisplayText} />;
const localizedMappedServiceDisplayText = <FormattedMessage {...messages.mappedServiceDisplayText} />;

/**
 * @param {object} props
 * @param {boolean} props.isRequestedShippingServiceMapped - Whether a mapping exists for the requested shipping service
 * @returns {React.JSX.Element}
 */
export const RequestedServiceModalLauncher = ({ isRequestedShippingServiceMapped }) => {
  const { isOpen, open, close } = useModal();
  const { fulfillmentPlanId, onApplyServiceMappingPackage, onServiceChangeWithSideEffects } = useFulfillmentPlannerContext();

  const requestedShippingServiceMapping = useSelector((state) => {
    const fulfillmentPlannerProperties = new FulfillmentPlannerProperties({
      state,
      fulfillmentPlanId,
    });
    return fulfillmentPlannerProperties.requestedShippingServiceMapping;
  });

  const onSaveSuccess = useCallback(
    ({ serviceCollectionGuid, serviceId, sellerLabelProviderId, packageTypeId }) => {
      close();

      if ((serviceId && sellerLabelProviderId) || serviceCollectionGuid) {
        onServiceChangeWithSideEffects({
          serviceId,
          sellerLabelProviderId,
          serviceCollectionGuid,
        });
      }
      if (packageTypeId) {
        onApplyServiceMappingPackage(packageTypeId);
      }
    },
    [close, onApplyServiceMappingPackage, onServiceChangeWithSideEffects],
  );
  return (
    <>
      <Button className={style['service-map-button']} onClick={open} theme='link'>
        ({isRequestedShippingServiceMapped ? localizedMappedServiceDisplayText : localizedUnmappedServiceDisplayText})
      </Button>
      {isOpen && (
        <SaveRequestedService onSuccess={onSaveSuccess}>
          {({ onSave, isSaving }) => {
            return (
              <ModalPortal onClose={close}>
                <MapRequestedServiceModal
                  isLoading={isSaving}
                  requestedServiceCode={requestedShippingServiceMapping.requestedServiceCode}
                  saveRequestedServiceMapping={onSave}
                  selectedPackageTypeId={requestedShippingServiceMapping.packageTypeId}
                  selectedServiceCollectionGuid={requestedShippingServiceMapping.serviceCollectionGuid}
                  selectedServiceId={requestedShippingServiceMapping.serviceId}
                  storeGuid={requestedShippingServiceMapping.storeId}
                />
              </ModalPortal>
            );
          }}
        </SaveRequestedService>
      )}
    </>
  );
};
